<template>
  <project-template title="样本量计算" nextBtnText="下一步：方案成本" @lastClick="lastClick" @nextClick="nextClick">
    <template v-slot:leftContent>
      <div v-for="(item, index) in list" :class="['period-item-card', cur === index && 'cur']"
        @click="viewPeriodItem(item, index)">
        <simple-type></simple-type>
        <strong>{{ item }}</strong>
        <a-tag color="green">
          样本总量：{{ result }}
        </a-tag>
        <a-icon type="right" class="card-img-right"></a-icon>
      </div>
    </template>
    <template v-slot:rightContent>
      <a-form-model layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="handleSubmit">
        <div class="calc">
          <div class="title">Design</div>
          <a-form-model-item label="选择统计方法" prop="calType">
            <a-select v-model="form.calType" style="width: 100%">
              <a-select-option v-for="item in selectList" :key="item" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <hr>
        <div class="calc">
          <div class="title">Input</div>

          <a-form-model-item prop="α">
            <template v-slot:label>
              <span>
                ① Ⅰ型错误概率(α)&nbsp;
                <a-tooltip title="即假设检验中的检验水准，假设检验的第Ⅰ类错误概率，这是我们错误拒绝零假设的概率。">
                  <a-icon type="question-circle-o" />
                </a-tooltip>
              </span>
            </template>
            <a-input v-model="form.α" placeholder="Please input α" />
          </a-form-model-item>

          <a-form-model-item prop="power">
            <template v-slot:label>
              <span>
                ② 检验效能（power）&nbsp;
                <a-tooltip title="即把握度1-β，正确拒绝零假设的概率。β为假设检验时出现第Ⅱ类错误的概率。">
                  <a-icon type="question-circle-o" />
                </a-tooltip>
              </span>
            </template>
            <a-input v-model="form.power" placeholder="Please input power" />
          </a-form-model-item>

          <a-form-model-item prop="p0">
            <template v-slot:label>
              <span>
                ③ 非暴露组发病率（p0）&nbsp;
                <a-tooltip title="在前瞻性研究中，p0为非暴露患者发生结局的概率。">
                  <a-icon type="question-circle-o" />
                </a-tooltip>
              </span>
            </template>
            <a-input v-model="form.p0" placeholder="Please input p0" />
          </a-form-model-item>

          <a-form-model-item prop="r">
            <template v-slot:label>
              <span>
                ④ 相对危险度(RR)&nbsp;
                <a-tooltip title="在前瞻性研究中，暴露组与非暴露组的发病率之比。">
                  <a-icon type="question-circle-o" />
                </a-tooltip>
              </span>
            </template>
            <a-input v-model="form.r" placeholder="Please input RR" />
          </a-form-model-item>

          <a-form-model-item prop="m">
            <template v-slot:label>
              <span>
                ⑤ 非暴露组/暴露组人数比例(m) &nbsp;
                <a-tooltip title="在前瞻性研究中，非暴露组与暴露组的人数比例。">
                  <a-icon type="question-circle-o" />
                </a-tooltip>
              </span>
            </template>
            <a-input v-model="form.m" placeholder="Please input m" />
          </a-form-model-item>

          <a-form-model-item style="text-align: right;margin-top: 15px;">
            <!-- <a-button type="primary" html-type="submit">Calculate</a-button> -->
            <a-button type="primary" @click="handleSubmit">Calculate</a-button>
          </a-form-model-item>
        </div>
        <hr>
        <div class="calc">
          <div class="title">Description</div>
          <p style="color: white">
            本研究为前瞻性队列研究，暴露组与非暴露组为1:{{ form.m }}。既往研究表明，非暴露组的发病率为{{ form.p0 }}，预估暴露组与非暴露组的相对风险为{{ form.r }}，研究需要纳入{{ a }}名暴露和{{ b }}名对照，才能用于检验组间差异，检验效能为{{ form.power}}，与此零假设检验相关的发生Ⅰ类错误概率为{{form.α}}。
          </p>
        </div>

      </a-form-model>
    </template>
  </project-template>


</template>

<script>
import { getAction, postAction } from '@api/manage'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
export default {
  name: 'StepSix',
  components: { ProjectTemplate },
  data() {
    return {
      cur: 0,
      result: 0,
      a:0,
      b:0,
      list: ['队列研究样本量'],
      selectList: ['卡方检验', 'fisher精确检验'],

      form: {
        type: '队列研究样本量',
        calType: '卡方检验',
        α: '0.05',
        power: '0.8',
        p0: '0.2',
        r: '1.5',
        m: '4',
      },
      rules: {
        calType: [
          { required: true, message: 'Please input calType!', trigger: 'change' },
        ],
        α: [
          { required: true, message: 'Please input α!', trigger: 'blur' },
        ],
        power: [
          { required: true, message: 'Please input power!', trigger: 'blur' },
        ],
        p0: [
          { required: true, message: 'Please input p0!', trigger: 'blur' },
        ],
        r: [
          { required: true, message: 'Please input RR!', trigger: 'blur' },
        ],
        m: [
          { required: true, message: 'Please input m!', trigger: 'blur' },
        ]
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          //console.log(11,this.form)
          const res = await postAction('/tempconfig/tempConfigCostCategory/calculate', this.form)
          if (res.success) {
            this.a=Math.ceil(res.result)
            this.b= Math.ceil(res.result*this.form.m)
            this.result = this.a+this.b;
            sessionStorage.setItem('result', this.result)
          }else{
            this.$message.error(res.message)
          }
        } else {
          console.error('Validation failed!');
        }
      });
    },
    async getData() {
      const res = await getAction('/tempconfig/tempConfigSampleSettings/list')
      if (res.success) {
        this.list = res.result;
      }
    },
    viewPeriodItem(item, index) {
      this.cur = index;
      this.selectList = item.list;
    },
    nextClick() {
      this.$emit('next')
    },
    lastClick() {
      this.$emit('last')
    }
  },
};
</script>

<style scoped lang="less">
.project-template {
  .period-item-card {
    display: flex;
    align-items: center;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 12px;
    padding: 16px 10px;
    margin-bottom: 20px;
    background-size: cover;
    background-image: url(~@/assets/item_bg.png);

    .card-img {
      margin-right: 10px;
    }

    .card-img-right {
      margin-left: auto;
      margin-top: 3px;
    }

    strong {
      font-size: 18px;
      font-weight: normal;
      margin: 0 10px;
    }
  }

  .cur {
    background-color: #376eff;
    background-image: none;
  }

  .title {
    color: white;
    font-size: 20px;
    margin-bottom: 20px;
  }

  .calc {
    // padding: 20px;

    .calc-input {
      color: white;
      display: flex;
      justify-content: center;
      column-gap: 30px;

      dl {
        display: flex;
        flex: 1;
        align-items: center;
        column-gap: 10px;
      }

      dt {
        font-size: 18px;
        width: 55px;
        text-align: right;
      }

      dd {
        flex: 1;
        margin: 0;

        input {
          width: 100%;
        }
      }
    }

    .ant-form-item {
      margin-bottom: 0;
    }

    .ant-btn-primary {
      background-color: #376eff;
      border-color: #376eff;
    }
  }

  .description {
    color: white;
    font-size: 16px;
  }
}

.ant-form {
  /deep/ .ant-form-item-label>label {
    color: white;
  }
}
</style>